import { RootModel } from '../store';

export const CurrencySelector = (state: RootModel) => ({
  currency: state.currency.currency,
});
